export const imgArd = require("./ard-logo.jpg");
export const imgHFBK = require("./HFBK_Logo_Hamburg.jpg");
export const imgKeystone = require("./keystone-logo.jpg");
export const imgNdr = require("./NDR1.jpg");
export const imgNdrOld = require("./NDR2.jpg");
export const imgRadiBremen = require("./radiobremen4.jpg");
export const imgUniHamburg = require("./university-hamburg-germany.jpg");
export const imgVita = require("./vita.jpg");

export const imgSb = require("./sb.png");
